export const TRUE = true
export const FALSE = false
export const NULL = null
export const UNDEFINED = void 0

export const RAW_DATE = 'date'
export const RAW_ARRAY = 'array'
export const RAW_STRING = 'string'
export const RAW_BOOLEAN = 'boolean'
export const RAW_NUMERIC = 'numeric'
export const RAW_NUMBER = 'number'
export const RAW_OBJECT = 'object'
export const RAW_FUNCTION = 'function'

export const RAW_HORIZONTAL = 'horizontal'
export const RAW_VERTICAL = 'vertical'
export const RAW_INLINE = 'inline'

export const RAW_SMALL = 'small'
export const RAW_DEFAULT = 'default'
export const RAW_LARGE = 'large'

export const RAW_ALWAYS = 'always'
export const RAW_NEVER = 'never'

export const RAW_HOVER = 'hover'
export const RAW_CLICK = 'click'
export const RAW_CUSTOM = 'custom'


export const RAW_CENTER = 'center'
export const RAW_MIDDLE = 'middle'

export const RAW_TOP = 'top'
export const RAW_TOP_START = 'top-start'
export const RAW_TOP_END = 'top-end'
export const RAW_BOTTOM = 'bottom'
export const RAW_BOTTOM_START = 'bottom-start'
export const RAW_BOTTOM_END = 'bottom-end'
export const RAW_LEFT = 'left'
export const RAW_LEFT_START = 'left-start'
export const RAW_LEFT_END = 'left-end'
export const RAW_RIGHT = 'right'
export const RAW_RIGHT_START = 'right-start'
export const RAW_RIGHT_END = 'right-end'

export const RAW_TYPE_PRIMARY = 'primary'
export const RAW_TYPE_SUCCESS = 'success'
export const RAW_TYPE_WARNING = 'warning'
export const RAW_TYPE_ERROR = 'error'
export const RAW_TYPE_INFO = 'info'
export const RAW_TYPE_DASHED = 'dashed'
export const RAW_TYPE_LINK = 'link'
export const RAW_TYPE_TEXT = 'text'
export const RAW_TYPE_TITLE = 'title'
export const RAW_TYPE_CONTENT = 'content'
export const RAW_TYPE_MUTED = 'muted'

export const RAW_SHAPE_CIRCLE = 'circle'
export const RAW_SHAPE_ROUND = 'round'

export const RAW_EVENT_KEYPRESS = 'keypress'
export const RAW_EVENT_KEYDOWN = 'keydown'
export const RAW_EVENT_KEYUP = 'keyup'
export const RAW_EVENT_MOUSEDOWN = 'mousedown'
export const RAW_EVENT_MOUSEMOVE = 'mousemove'
export const RAW_EVENT_MOUSEUP = 'mouseup'
export const RAW_EVENT_SCROLL = 'scroll'
export const RAW_EVENT_RESIZE = 'resize'
export const RAW_EVENT_BEFORE_DESTROY = 'beforeDestroy.hook'

export const RAW_DARK = 'dark'
export const RAW_LIGHT = 'light'

export const RAW_THEME_ARRAY = [
  RAW_DARK,
  RAW_LIGHT,
]

export const RAW_STATUS_ARRAY = [
  RAW_TYPE_INFO,
  RAW_TYPE_SUCCESS,
  RAW_TYPE_WARNING,
  RAW_TYPE_ERROR,
]

export const RAW_TYPE_ARRAY = [
  RAW_TYPE_PRIMARY,
  RAW_TYPE_INFO,
  RAW_TYPE_SUCCESS,
  RAW_TYPE_WARNING,
  RAW_TYPE_ERROR,
]

export const RAW_SIZE_ARRAY = [
  RAW_SMALL,
  RAW_DEFAULT,
  RAW_LARGE,
]

export const RAW_PLACEMENT_ARRAY = [
  RAW_TOP,
  RAW_TOP_START,
  RAW_TOP_END,
  RAW_BOTTOM,
  RAW_BOTTOM_START,
  RAW_BOTTOM_END,
  RAW_LEFT,
  RAW_LEFT_START,
  RAW_LEFT_END,
  RAW_RIGHT,
  RAW_RIGHT_START,
  RAW_RIGHT_END
]

export const WINDOW = window
export const DOCUMENT = document
export const BODY = DOCUMENT.body

export const HOVER_DELAY = 100